<template>
  <v-row justify="center" class="mx-xl-6 mx-lg-6 mx-md-6" no-gutters>
    <v-col xl="8" lg="9" md="10" sm="12" cols="12">
      <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
        <v-col class="pr-xl-3 pr-lg-3 pr-md-3" cols="12">
          <v-card outlined>
            <v-toolbar flat dense color="#F9F9F9">
              <v-toolbar-title class="px-2">
                <v-skeleton-loader type="text"></v-skeleton-loader>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-left py-0 px-4">
              <v-skeleton-loader v-for="i in size" type="list-item-two-line" :key="i + '_item'"></v-skeleton-loader>
              <v-skeleton-loader type="actions"></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FormLoader',
  props: {
    size: {
      type: Number,
      default: 5
    }
  }
}
</script>
